import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  createSession: (sessionToken, userData) => 
    api.post('/auth/session', { session_token: sessionToken, user_data: userData }),
  
  getCurrentUser: () => api.get('/auth/me'),
  
  logout: () => api.post('/auth/logout'),
};

// Products API
export const productsAPI = {
  getAll: (params = {}) => api.get('/products', { params }),
  
  getById: (id) => api.get(`/products/${id}`),
};

// Orders API
export const ordersAPI = {
  create: (orderData) => api.post('/orders', orderData),
  
  getAll: () => api.get('/orders'),
  
  getById: (id) => api.get(`/orders/${id}`),
};

// Reviews API
export const reviewsAPI = {
  create: (reviewData) => api.post('/reviews', reviewData),
  
  getPending: () => api.get('/reviews/pending'),
  
  getUserReviews: () => api.get('/reviews/user'),
};

// Referrals API
export const referralsAPI = {
  getCode: () => api.get('/referrals/code'),
  
  getStats: () => api.get('/referrals/stats'),
};

// Institutional API
export const institutionalAPI = {
  register: (data) => api.post('/institutional/register', data),
  
  getProfile: () => api.get('/institutional/profile'),
};

// Designer API
export const designerAPI = {
  register: (portfolioUrl) => api.post('/designer/register', null, { params: { portfolio_url: portfolioUrl } }),
  
  submitDesign: (designData) => api.post('/designer/designs', designData),
  
  getDesigns: () => api.get('/designer/designs'),
  
  getStats: () => api.get('/designer/stats'),
};

// Investor API
export const investorAPI = {
  register: () => api.post('/investor/register'),
  
  getOpportunities: () => api.get('/investor/opportunities'),
  
  invest: (investmentData) => api.post('/investor/invest', investmentData),
  
  getPortfolio: () => api.get('/investor/portfolio'),
};

// Admin API
export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  
  getUsers: (params = {}) => api.get('/admin/users', { params }),
  
  approveUser: (userId) => api.put(`/admin/users/${userId}/approve`),
  
  rejectUser: (userId, reason) => api.put(`/admin/users/${userId}/reject`, null, { params: { reason } }),
  
  getPendingDesigns: () => api.get('/admin/designs/pending'),
  
  approveDesign: (designId, notes) => api.put(`/admin/designs/${designId}/approve`, null, { params: { notes } }),
  
  rejectDesign: (designId, reason) => api.put(`/admin/designs/${designId}/reject`, null, { params: { reason } }),
};

export default api;
